import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'pc-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent implements OnInit {
  @Input() errors?: ValidationErrors | null;
  @Input() isIconVisible = true;

  constructor() {}

  ngOnInit(): void {}
}
